(function($) {
  
  (function InitCustomSpeakerHeights(){
    var maxHeight = 0;
    $('.event-speakers ul').find('div, li').each(function() {
      if($(this).is("li")){
        var thisHeight = $(this).innerHeight();
        if(thisHeight > maxHeight) maxHeight = thisHeight;
      } else if($(this).hasClass('open-info')){
        $(this).css('height',maxHeight);
        maxHeight = 0;
      }
    });
  })();
  var infoFlag = false;
  $(".slide-panels-nav li > div").not('.empty-info').on('click', function(e) {
    if($(window).width() >= 768){
      if(!infoFlag){
        infoFlag = true;
        e.preventDefault();
        var $this = $(this).closest('li');
        if($this.hasClass('open')){
          $this.removeClass('open');
          if($this.prevUntil('div').length > 0){
            $this.fadeOut(400);
          }
          var infoElem;
          if($this.nextUntil('div').length > 0) infoElem = $this.nextUntil('div').next('.open-info');
          else                                  infoElem = $this.next('.open-info');
          infoElem.fadeOut(400, function(){
            infoElem.prevUntil('div').fadeIn(400);
            infoFlag = false;
          });
        } else {
          var liArr     = [];
          var currInfo;
          var currInfoId= '';
          var speakData = $this.find('.speak-info').html();
          var prevArr   = $this.prevUntil('div').fadeOut(400);
          var nextArr   = $this.nextUntil('div').fadeOut(400);
          for(var i=0;i<prevArr.length;i++){
            liArr.push(prevArr[i].id);
          }
          for(var i=0;i<nextArr.length;i++){
            liArr.push(nextArr[i].id);
          }
          if($this.nextUntil('div').length > 0)
            currInfo = $this.nextUntil('div').next('.open-info');
          else
            currInfo = $this.next('.open-info');
          currInfoId = currInfo.attr('id');
          if($this.prevUntil('div').length > 0){
            $this.fadeOut(400, function(){
              $this.fadeIn(400);
              currInfo.fadeIn(400);
              currInfo.find('.data').html(speakData);
              infoFlag = false;
            });
          } else {
            setTimeout(function(){
              currInfo.fadeIn(400);
              currInfo.find('.data').html(speakData);
              infoFlag = false;
            },400);
          }
          
          var parent = $this.closest('ul');
          if(parent.find('div.open-info'))
          parent.find('div.open-info').not('#'+currInfoId).fadeOut(400, function(){
            parent.find('li').each(function(index){
              if(liArr.indexOf($(this).attr('id')) < 0)
                $(this).fadeIn(400).removeClass('open');
                $this.addClass('open');
            });
          });
          $this.addClass('open');
        }
      }
    } else {
      e.preventDefault();
      var $thisel = $(this).closest('li');
      if(!$thisel.children('div').hasClass('empty-info')){
        $thisel.children('div').fadeOut(400, function(){
          $thisel.children('span').fadeIn(400);
        });
      }
    }
	});
	
  $(".event-speakers").on('click','.close-speaker', function(e) {
    e.preventDefault();
    if($(window).width() >= 768){
      var elem = $(this).closest('.open-info');
      elem.prevUntil('li.open').prev('li.open').removeClass('open').fadeOut(400);
      elem.prev('li.open').removeClass('open').fadeOut(400);
      elem.fadeOut(400, function(){
        elem.prevUntil('div').fadeIn(400);
      });
    } else {
      var $this = $(this).closest('li');
      $this.children('span').fadeOut(400, function(){
        $this.children('div').fadeIn(400);
      });
    }
  });
  
})(jQuery); // Fully reference jQuery after this point.
